export default {
  alias   : 'regulations_tipo',
  route   : '/app/normatividad/regulations_tipos',
  hash    : false,
  store   : false,
  name    : 'tip_description',
  key     : 'id',
  /*relations : [
      {
          attribute : 'unidades',
          alias     : 'unidades',
          module    : 'unit'
      }
    ],*/
  default : {
    id                : null,
    tip_description   : null,
    tip_siglas        : [],
    tip_show          : false,
    tip_show_portal   : false,
    tip_uso_obras     : false,
    tip_autoincrement : false,
    tip_adenda        : false,
    created_at        : null,
    updated_at        : null,
  }
}
